import * as angular from 'angular';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { app } from '../../app';
import { countries } from '../../data/countries';

app.directive('spPhoneNumberInput', spPhoneNumberInput);

/** @ngInject */
function spPhoneNumberInput() {

            const PNU = PhoneNumberUtil.getInstance();

            return {
                restrict : 'E',
                scope : {requiredNumber : "=",directiveNumber : "="},
                templateUrl : require('./sp-phone-number-input.html'),
                require : 'ngModel',
                link : function(scope, iElement, iAttrs, ngModelCtrl) {
                    scope.allCountries = Object.keys(countries).map(key => ({
                        countryCode: key,
                        countryName: countries[key]
                    }));
                    scope.onlyNumbers = /^[0-9]+$/;
                    scope.countryCode = null;
                    scope.number = null;
                    var required = true;
                    if(angular.isDefined(scope.requiredNumber)){
                        required = scope.requiredNumber;
                    }
                    ngModelCtrl.$formatters.push(function(modelValue) {
                        if (!PNU.isPossibleNumberString(modelValue)) {
                            return {};
                        }
                        if (!PNU.isValidNumber(PNU.parse(modelValue))) {
                            scope.isInvalidNumber = null;
                            scope.isValidNumber = null;
                            return {
                                countryCode : null,
                                number : null
                            };
                        }
                        const countryCode = PNU.parse(modelValue).getCountryCode();
                        const number = PNU.parse(modelValue).getNationalNumber();
                        return {
                            countryCode: `${countryCode}`,
                            number: `${number}`
                        };
                    });
                    ngModelCtrl.$render = function() {
                        scope.countryCode = ngModelCtrl.$viewValue.countryCode;
                        scope.number = ngModelCtrl.$viewValue.number;
                        const regionCode = PNU.getRegionCodeForCountryCode(scope.countryCode);
                        scope.selectedCountry = countries[regionCode];
                    };
                    ngModelCtrl.$parsers.push(function(viewValue) {
                        if(!viewValue.countryCode || !viewValue.number){
                            return "";
                        }
                        return "+" + viewValue.countryCode + viewValue.number;
                    });
                    scope.$watch('countryCode + number', function() {
                        if (scope.countryCode && scope.number) {
                            const number = `+${scope.countryCode}${scope.number}`;
                            scope.isInvalidNumber = !PNU.isPossibleNumberString(number) || !PNU.isValidNumber(PNU.parse(number));
                            scope.isValidNumber = !scope.isInvalidNumber;                            
                            if(scope.isValidNumber && scope.number.charAt(0) == '0'){
                                scope.number = scope.number.slice(1);
                            }                                                       
                        }
                        ngModelCtrl.$setViewValue({
                            countryCode : scope.countryCode,
                            number : scope.number
                        });
                        if(!required && (scope.number==null || scope.number.length == 0)){
                            ngModelCtrl.$setValidity("err", true);
                        }else {
                            ngModelCtrl.$setValidity("err", !!scope.isValidNumber);
                        }
                    });
                    iElement.find('select').on("change", function(event) {
                        scope.countryCode = PNU.getCountryCodeForRegion(scope.selectedCountry.countryCode);
                        scope.$apply();
                    });
                    document.getElementById('phoneNumberInput').onkeypress = function(evt) {
                        var charCode = evt.charCode;
                        if ((charCode > 47 && charCode < 58) || charCode == 0)
                            return true;
                        return false;
                    }
                }
            }
}



// WEBPACK FOOTER //
// ./src/portal/directives/sp-phone-number-input/sp-phone-number-input.directive.js